const getters = {
  storage(state) {
    return state.storage;
  }
};

export default getters;
